// extracted by mini-css-extract-plugin
export default {"container":"HeaderOnly_container__RZ3Ql"};